import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-payroll',
} as const satisfies Location
